import { NFT_MARKETPLACE_ABI } from '@/abis/nft-marketplace';

export const NFT_MARKETPLACE_CONTRACT_CONFIG = {
	address: (import.meta.env.VITE_NFT_MARKET_PLACE_CONTRACT_ADDRESS || '') as `0x${string}`,
	abi: NFT_MARKETPLACE_ABI,
} as const;
